import useWindowWidth from './useWindowWidth';

const useIsTablet = () => {
	const width = useWindowWidth();

	return width <= 991;
};

export default useIsTablet;
